import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const Card = ({ header = '', body = '', footer = '', children = null, className, ...rest }) => {
	return (
        <div className={classNames(['card', className])} {...rest}>
			{children}
		</div>
	);
};

export default Card;
